import IconButton from 'components/Luxkit/Button/IconButton'
import LineTimesIcon from 'components/Luxkit/Icons/line/LineTimesIcon'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import { rem } from 'polished'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import ImageCarousel from 'components/Luxkit/Carousel/ImageCarousel'

const GalleryModal = styled(ModalBase)`
  width: 100%;
  height: 100%;
  max-width: 100% !important;
  max-height: 100%;
  display: flex;
  background-color: ${({ theme }) => theme.palette.neutral.one};
`

const StyledCarousel = styled(ImageCarousel)`
  height: 100%;
  width: 100%;
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`

const CloseButton = styled(IconButton)`
  position: absolute;
  margin: ${rem(12)};
  top: 0;
  right: 0;
`

interface Props {
  review: App.Review;
  isOpen: boolean;
  initialIndex: number;
  onRequestClose: () => void;
}

function UserReviewGallery(props: Props) {
  const { review, isOpen, initialIndex, onRequestClose } = props

  const slides = useMemo(() => {
    return review.photos.map((photo) => ({
      type: 'image',
      id: photo.imageId,
    }))
  }, [review])

  return (
    <GalleryModal
      isOpen={isOpen}
    >
      <StyledCarousel
        images={slides}
        imageParams={{
          fit: 'none',
          aspectRatio: 'auto',
          gravity: 'center',
          quality: 'best',
        }}
        arrowBehaviour="always-visible"
        defaultIndex={initialIndex}
      />
      <CloseButton
        variant="dark"
        kind="primary"
        shape="circle"
        data-direction="right"
        onClick={onRequestClose}
      >
        <LineTimesIcon />
      </CloseButton>
    </GalleryModal>
  )
}

export default UserReviewGallery
